import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import _ from 'lodash';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { TenantPermissionsComponent } from '../tenant-permissions/tenant-permissions.component';
import { DeleteTenantGrouproleDialogComponent } from '../delete-tenant-grouprole-dialog/delete-tenant-grouprole-dialog.component';
import { TenantsButtonRendererComponent } from '../../tenants-button-renderer/tenants-button-renderer.component';

@Component({
  selector: 'app-tenant-grouproles-button-renderer',
  templateUrl: './tenant-grouproles-button-renderer.component.html',
  styleUrls: ['./tenant-grouproles-button-renderer.component.css']
})
export class TenantGrouprolesButtonRendererComponent implements ICellRendererAngularComp {

  params:any;

  icon_edit!: string;
  icon_delete!: string;
  icon_view!:string;
  routerLinkEditTenantGroupRole!: string;
  tenantName!: string;
  tenantRoles: string[] = [];

  constructor(
    public dialog: MatDialog,
    public translate: TranslateService,
    public tenantService: TenantService,
    private notificationService: NotificationService,
    ) { }

  refresh(params: ICellRendererParams): boolean {
    const dataParams = params.colDef?.cellRendererParams;
    this.routerLinkEditTenantGroupRole = _.isFunction(dataParams.routerLinkEditPlatformGroupRole) ? dataParams.routerLinkEditPlatformGroupRole(params) : _.get(params.data, dataParams.routerLinkEditGroupRole);
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    // console.log("------> tenant-group-roles-button-renderer paramns: ", this.params);


    this.icon_edit = this.params.icon_edit || null;
    this.icon_delete = this.params.icon_delete || null;
    this.icon_view = this.params.icon_view || null;

    this.routerLinkEditTenantGroupRole = this.params.routerLinkEditTenantGroupRole || null;
    this.refresh(params);

    //this.tenantName = localStorage.getItem('current-tenant-name') as string;
    this.tenantName = this.tenantService.currentTenantName;
    this.tenantService.getToken(this.tenantName).subscribe({
      next:(token) =>{
        this.tenantRoles = this.tenantService.getTenantRoles(token);
        // console.log("------> tenant-group-roles-button-renderer tenant roles: ", this.tenantRoles);
      }
    })
  }

  onClick($event: any) {
    if(this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component

      const params = {
        event: $event,
        rowData: this.params.node.data
      }
      console.log("------> onClick params: ", params);
      console.log("------> onClick params: ", this.params);
      this.params.onClick(this.params);
    }
  }

  viewTenantPermissions() {
    console.log("------> vi")

    const rowData = [this.params.node.data]; 
    const tenantGroupRole = rowData[0];
    const tenantGrpRoleId = rowData[0].id;   
    //const tenantDb = localStorage.getItem('current-tenant-db') as string;

    this.tenantService.getTenantGroupRole(this.tenantService.tempTenant, tenantGrpRoleId, new GenericFilter()).subscribe({
//      this.tenantService.getTenantGroupRole(this.tenant, tenantGrpRoleId, new GenericFilter()).subscribe({
        //this.platformGroupRoleService.getPlatformPermissions().subscribe({
      next: (tenantGroupRole) => {
        //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["PLATFORMPERMISSIONSRETRIEVED"]} `);
        this.dialog.open(TenantPermissionsComponent, {width: '500px', data:{tenantName: this.tenantService.tempTenant, tenantGroupRole: tenantGroupRole, tenantGroupRolePermissions: null, tenantRoles: this.tenantRoles}});
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PLATFORMPERMISSIONSRETRIEVEDERROR"]}`)
    });
  }

  deleteTenantGroupRole(){
    const rowData = [this.params.node.data]; 
    //const tenantDb = localStorage.getItem('current-tenant-db') as string;
    console.log("tenant-grouproles-button-renderer rowData=", rowData)

    this.tenantService.checkForTenantGroupRoleUsers(this.tenantService.tempTenant, rowData[0].id, new GenericFilter()).subscribe({
      next:(usersExist:any) => {
        console.log("tenant-grouproles-button-renderer usersExist=", usersExist);

        if(usersExist === false){
          // this.tenantGroupRoleService.deleteTenantGroupRole(tenantDb, rowData[0].id).subscribe({
          //   //this.platformGroupRoleService.getPlatformPermissions().subscribe({
          //     next: () => {
          //       this.refresh(this.params);
          //       this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["TENANTGROUPROLEDELETED"]} `);
          //       //this.dialog.open(TenantPermissionsComponent, {width: '500px', data:{tenantGroupRole: tenantGroupRole, tenantGroupRolePermissions: null}});
          //     },
          //     error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["TENANTGROUPROLEDELETEDERROR"]}`)
          //   });


          const dialogRef = this.dialog.open(DeleteTenantGrouproleDialogComponent, { width: '500px', data: {rowData: rowData[0], tenantName: this.tenantService.tempTenant}});
          dialogRef.afterClosed().subscribe({
            next: () => {
              // this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["TENANTGROUPROLEDELETED"]} `);
              this.params.api.refreshInfiniteCache();
            },
            error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["TENANTGROUPROLEDELETEDERROR"]}`)
          });
          this.params.api.refreshInfiniteCache();
        }
        else
        {
          this.notificationService.warning(`${this.translate.data["WARN"]}`, `${this.translate.data["THERETENANTGROUPROLEUSERS"]} `);
        }
      }
    });
  }

  removeTenantGroupRole(){ // Zuweisung GroupRole User wird aufgehoben
      const rowData = [this.params.node.data]; 
      //const tenantDb = localStorage.getItem('current-tenant-db') as string;
      console.log("tenant-grouproles-button-renderer rowData=", rowData)
  
            this.tenantService.deleteUserFromTenantGroupRole(this.tenantService.tempTenant, rowData[0].id, this.tenantService.tempUserId).subscribe({
              //this.platformGroupRoleService.getPlatformPermissions().subscribe({
                next: () => {
                  this.refresh(this.params);
                  this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["TENANTGROUPROLEREMOVED"]} `);
                  this.params.api.refreshInfiniteCache();
                  //this.dialog.open(TenantPermissionsComponent, {width: '500px', data:{tenantGroupRole: tenantGroupRole, tenantGroupRolePermissions: null}});
                },
                error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["TENANTGROUPROLEDELETEDERROR"]}`)
              });
  
  
            // const dialogRef = this.dialog.open(DeleteTenantGrouproleDialogComponent, { width: '500px', data: {rowData: rowData[0], tenantName: this.tenantService.tempTenant}});
            // dialogRef.afterClosed().subscribe({
            //   next: () => {
            //     // this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["TENANTGROUPROLEDELETED"]} `);
            //     this.params.api.refreshInfiniteCache();
            //   },
            //   error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["TENANTGROUPROLEDELETEDERROR"]}`)
            // });
            this.params.api.refreshInfiniteCache();
        }
  
  


    // this.tenantGroupRoleService.deleteTenantGroupRole(tenantDb, rowData[0].id).subscribe({
    //   //this.platformGroupRoleService.getPlatformPermissions().subscribe({
    //     next: () => {
    //       this.refresh(this.params);
    //       this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["TENANTGROUPROLEDELETED"]} `);
    //       //this.dialog.open(TenantPermissionsComponent, {width: '500px', data:{tenantGroupRole: tenantGroupRole, tenantGroupRolePermissions: null}});
    //     },
    //     error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["TENANTGROUPROLEDELETEDERROR"]}`)
    //   });
  

  openTenantGroupRoleDeleteDialog() {
    const rowData = [this.params.node.data]; 
    console.log(rowData[0]);
  }

}